<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-3">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo sub">
                    <router-link to="/docentes/asignaturas">Docentes</router-link>
                    <i class="fa fa-chevron-right"></i> Asignaturas
                  </span>
                </div>
                <div class="col-6 col-md-6"></div>
              </div>

              <div class="contenido">
                <div class="row" v-if="this.asignaturas != null && this.asignaturas.length > 0">
                  <div class="col-12">
                    <v-client-table :columns="columns" v-model="asignaturas" :options="options">
                      <!-- <div slot="grupos" slot-scope="props">
                        <div v-for="item in props.row.grupos" v-bind:key="item.id_grupo">
                          <router-link
                            class="link"
                            :to="'/dashboard/alumnos/grupo/'+item.id_grupo+'/'+props.row.matricula"
                          >{{item.nombre}}</router-link>
                        </div>
                      </div>-->
                    </v-client-table>
                  </div>
                </div>

                <div class="row" v-if="this.asignaturas != null && this.asignaturas.length == 0">
                  <div class="col-12 col-md-6 pb-3">
                    <div class="card py-5 text-center">
                      <h3 class>Hasta el momento no tienes asignaturas para este ciclo escolar.</h3>
                    </div>
                  </div>
                </div>

                <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                  <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style>
@import "//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css";
</style>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      tiposervicio: "",
      columns: [
        "numero",
        "nombre",
        "programa",
        "asignatura",
        "ciclo_escolar_ano",
        "ciclo_escolar",
        "horario"
      ],
      datos: null,
      asignaturas: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          numero: "ID de Grupo",
          nombre: "Grupo",
          programa: "Programa",
          asignatura: "Asignatura",
          ciclo_escolar_ano: "Año",
          ciclo_escolar: "Ciclo",
          horario: "Horario",
         
        },
        editableColumns: ["name"],
        sortable: ["matricula", "nombre", "user_email", "grupos"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu
  },
  mounted: function() {
    this.$store.state.user = JSON.parse(this.$cookie.get("useriee"));
    console.log("user");
    console.log(this.$store.state.user);

    AOS.init();
    this.consulta();
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        user: this.$store.state.user
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "docentes/cuenta/consulta-asignaturas.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.asignaturas = res.asignaturas;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

